// Alpine.js Plugins
document.addEventListener('alpine:init', () => {
  Alpine.plugin('colorPalette', (Alpine) => {
    // Add a magic property for color palette operations
    Alpine.magic('colorPalette', (el) => {
      return {
        // Get dominant color from an image
        getDominantColor: (imageElement) => {
          try {
            const color = colorThief.getColor(imageElement)
            return `rgb(${color[0]}, ${color[1]}, ${color[2]})`
          } catch (error) {
            console.error('Error getting dominant color:', error)
            return null
          }
        },

        // Get color palette from an image (default 5 colors)
        getPalette: (imageElement, colorCount = 5) => {
          try {
            const palette = colorThief.getPalette(imageElement, colorCount)
            return palette.map(color => `rgb(${color[0]}, ${color[1]}, ${color[2]})`)
          } catch (error) {
            console.error('Error getting color palette:', error)
            return []
          }
        },

        // Get the most vibrant color from the palette
        getVibrantColor: (imageElement) => {
          try {
            const palette = colorThief.getPalette(imageElement, 5)
            // Find the most saturated color
            const vibrantColor = palette.reduce((max, current) => {
              const maxSaturation = Math.max(max[0], max[1], max[2]) - Math.min(max[0], max[1], max[2])
              const currentSaturation = Math.max(current[0], current[1], current[2]) - Math.min(current[0], current[1], current[2])
              return currentSaturation > maxSaturation ? current : max
            })
            return `rgb(${vibrantColor[0]}, ${vibrantColor[1]}, ${vibrantColor[2]})`
          } catch (error) {
            console.error('Error getting vibrant color:', error)
            return null
          }
        }
      }
    })

    // Add a directive to automatically extract colors from an image
    Alpine.directive('extract-colors', (el, { expression }, { evaluate }) => {
      const image = el.querySelector('img')
      if (!image) return

      // Wait for image to load
      if (image.complete) {
        extractColors()
      } else {
        image.addEventListener('load', extractColors)
      }

      function extractColors() {
        try {
          const colorCount = evaluate(expression) || 5
          const palette = colorThief.getPalette(image, colorCount)
          const colors = palette.map(color => `rgb(${color[0]}, ${color[1]}, ${color[2]})`)
          
          // Dispatch an event with the colors
          el.dispatchEvent(new CustomEvent('colors-extracted', {
            detail: { colors },
            bubbles: true
          }))
        } catch (error) {
          console.error('Error extracting colors:', error)
        }
      }
    })
  })
}) 